<template>
  <div class="competitor-person">
    <button @click="remove"><i class="el-icon-delete" title="Supprimer"/></button>
    <input
      class="order"
      type="text"
      title="Ordre du concurrent"
      @change="changeOrderPerson"
      :value="competitorPerson.order" />
    <img
      class="flag"
      v-for="country in competitorPerson.countries"
      :key="country.id"
      :src="countryUrl(country.id)"
      :title="country.nameFr" />
    <el-avatar class="photo" :src="photo" size="small">
      <i class="el-icon-user-solid"></i>
    </el-avatar>
    <span :title="personId"><small>{{ firstname }}</small><strong>{{ name }}</strong>&nbsp;[{{ personId }}]</span>
  </div>
</template>

<script>
export default {
  name: 'SportGamesCompetitorPerson',
  props: {
    competitorPerson: Object
  },
  computed: {
    photo () { return 'https://media.api.idalgo.info/Person/100x141/person_' + this.personId + '.jpg' },
    person () { return this.competitorPerson.person },
    personId () { return this.person ? this.person.id : '' },
    firstname () { return this.person ? this.person.firstnameFr : '' },
    name () { return this.person ? this.person.nameFr : '' }
  },
  methods: {
    countryUrl (countryId) { return 'https://media.api.idalgo.info/Country/svg/country_' + countryId + '.svg' },
    changeOrderPerson (event) {
      this.$store.dispatch('Sport/CompetitorPerson/put', { id: this.competitorPerson.id, order: event.target.value })
    },
    remove () {
      this.$store.dispatch('Sport/CompetitorPerson/delete', this.competitorPerson.id)
    },
    errorHandler () { return true }
  }
}
</script>

<style scoped>
  .competitor-person{
    display:flex;
    align-items:center;
    margin-left:10px
  }
  .competitor-person > button > i{
    color:red
  }
  .competitor-person > input{
    width:20px;
    margin-left:5px;
    text-align:right
  }
  .competitor-person > img{
    width:20px;
    border-radius:2px;
    border:1px solid var(--color-disable-bg);
    margin-left:5px
  }
  .competitor-person > .photo > img{
    width:100%
  }
  .competitor-person > span{
    font-size:14px;
    margin-left:5px
  }
  .competitor-person > span > small{
    margin-right:5px
  }
</style>
<style>
  .competitor-person > .photo > img{
    width:100%
  }
</style>
